import * as React from 'react'
import { Link } from '@mui/material'
import { useRecordContext } from 'react-admin'

export const ExternalRevenueUserUrlField = ({ source, urlPrefix }) => {
  const record = useRecordContext()
  const value = record && record[source]
  const userId = record && record.id

  if (value == null) {
    return null
  }

  if (userId == null) {
    return null
  }

  return (
    <Link href={`${urlPrefix}/${userId}`}>
      {value}
    </Link>
  )
}

ExternalRevenueUserUrlField.defaultProps = {
  addLabel: true,
}